module.exports = "/static/js/4605504cac4d96e939a89aac61960bc8.png";